<!-- MOLECULE: DevStatesExtension.vue -->
<!-- App bar extension tabs for the dev UI State Catalogue page. -->

<script setup lang="ts">
import { useDevStatesPage } from "@/composables/pages/dev/useDevStatesPage";

//
// Composables
//
const { activeTab, tabs } = useDevStatesPage();
</script>

<template>
  <div class="d-flex align-center w-100">
    <v-tabs v-model="activeTab" color="primary" class="pt-4">
      <v-tab
        v-for="tab in tabs"
        :key="tab.value"
        :value="tab.value"
        class="text-primary"
        rounded="none"
        density="compact"
        height="30"
      >
        <v-icon :icon="tab.icon" size="small" class="mr-2" />
        {{ tab.name }}
      </v-tab>
    </v-tabs>
  </div>
</template>
